import React from 'react';
import { CheckIcon, SparklesIcon, ShieldCheckIcon, UtensilsIcon } from 'lucide-react';
import { trackFbEvent } from '../utils/fbpixel';
export function PackCompletoExplainer() {
  const vipUrl = 'https://biologiafemenina.com.ar/checkouts/cn/hWNDGi3RMqtuWghQnIAfu1EA/es-ar?_r=AQABRioaIP6Q5RSnCD37HzrOuBgbOxu2z4ybZJmc2Tpk8Ds';
  const included = ['Los 6 Tomos completos del Método pH-ZERO', 'Los 3 Bonus originales del sistema'];
  const exclusives = [{
    icon: UtensilsIcon,
    title: 'NUTRICIONISTA',
    desc: 'Tu plan de alimentación día por día, con lista de súper lista para imprimir. Sabés exactamente qué comer (y qué evitar) para que la cándida no tenga de qué alimentarse.'
  }, {
    icon: ShieldCheckIcon,
    title: 'CUIDADOS',
    desc: 'El blindaje completo contra las recaídas: cómo cuidarte con tu pareja, qué ropa usar y los químicos invisibles que te están reinfectando sin que lo sepas.'
  }];
  return <section className="w-full bg-[#F8F5FC] px-4 py-12 sm:py-16" data-id="element-179">
      <div className="max-w-xl mx-auto" data-id="element-180">
        <div className="text-center mb-7" data-id="element-181">
          <span className="inline-flex items-center gap-1.5 bg-brand-violet/10 text-brand-violet text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-182">
            <SparklesIcon className="w-3.5 h-3.5" data-id="element-183" />
            La elección de la mayoría
          </span>
          <h2 className="text-[24px] sm:text-[30px] font-bold text-brand-text leading-tight" data-id="element-184">
            ¿Por qué casi todas eligen el{' '}
            <span className="text-brand-magenta" data-id="element-185">Pack Completo</span>?
          </h2>
          <p className="text-brand-muted text-[15px] leading-relaxed mt-3 max-w-md mx-auto" data-id="element-186">
            Porque eliminar la cándida es la mitad del camino. La otra mitad es
            que <strong className="text-brand-text" data-id="element-187">nunca más vuelva</strong>. Y
            eso es exactamente lo que suman estos dos accesos exclusivos.
          </p>
        </div>

        <div className="bg-white rounded-[20px] p-6 border-2 border-brand-violet shadow-[0_8px_40px_rgba(74,0,128,0.12)]" data-id="element-188">
          <div className="flex items-center justify-between gap-3 pb-4 mb-4 border-b border-brand-gray" data-id="element-189">
            <div data-id="element-190">
              <p className="text-brand-violet text-[11px] font-bold uppercase tracking-wider" data-id="element-191">
                👑 Pack Completo · Libertad Total
              </p>
              <h3 className="text-[18px] font-bold text-brand-text leading-tight mt-0.5" data-id="element-192">
                Todo lo del sistema + lo que evita las recaídas
              </h3>
            </div>
          </div>

          <p className="text-[12px] font-bold text-brand-muted uppercase tracking-wider mb-2" data-id="element-193">
            Incluye todo el sistema original
          </p>
          <ul className="flex flex-col gap-2 mb-6" data-id="element-194">
            {included.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-195">
                <CheckIcon className="w-5 h-5 text-brand-violet flex-shrink-0 mt-0.5" data-id="element-196" />
                <span className="text-[14px] text-brand-text leading-snug" data-id="element-197">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="text-[12px] font-bold text-brand-magenta uppercase tracking-wider mb-3" data-id="element-198">
            + 2 accesos exclusivos que NO vienen en el plan básico
          </p>
          <div className="flex flex-col gap-3 mb-6" data-id="element-199">
            {exclusives.map(({
            icon: Icon,
            title,
            desc
          }) => <div key={title} className="bg-[#F8F5FC] rounded-2xl p-4 border-l-4 border-brand-magenta" data-id="element-200">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-201">
                  <Icon className="w-5 h-5 text-brand-magenta flex-shrink-0" data-id="element-202" />
                  <span className="text-[14px] font-bold text-brand-text" data-id="element-203">
                    {title}
                  </span>
                </div>
                <p className="text-[13px] text-brand-muted leading-relaxed" data-id="element-204">
                  {desc}
                </p>
              </div>)}
          </div>

          <div className="bg-brand-violet/5 rounded-2xl p-4 mb-5 text-center" data-id="element-205">
            <p className="text-[14px] text-brand-text leading-relaxed" data-id="element-206">
              Sin estos dos accesos, podés eliminar la cándida hoy… pero seguir
              expuesta a lo que la trae de vuelta.{' '}
              <strong className="text-brand-violet" data-id="element-207">
                El Pack Completo te da la libertad de no volver a pasar por
                esto.
              </strong>
            </p>
          </div>

          <a href={vipUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: 'Pack Completo Explainer CTA',
          value: 29990,
          currency: 'ARS'
        })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[15px] rounded-xl py-3.5 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-208">
            QUIERO EL PACK COMPLETO — $29.990
          </a>
          <p className="text-center text-brand-muted text-[12px] mt-3" data-id="element-209">
            Acceso inmediato · Pago 100% seguro · 🇦🇷
          </p>
        </div>
      </div>
    </section>;
}